import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container, Box } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import AdvisoryQuestions from "../advisory/AdvisoryQuestions";
import PlantDiseasePrediction from "../advisory/PlantDiseasePredication";
import { useLocation } from "react-router-dom";

const Advisory = () => {
  const location = useLocation();
  const [view, setView] = useState("");

  useEffect(() => {
    if (location.pathname === "/farmer/advisory") {
      setView("advisory");
    } else if (location.pathname === "/farmer/crop-health") {
      setView("crop_health");
    } else {
      setView("advisory");
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Advisory - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Box>
          {view === "advisory" ? (
            <AdvisoryQuestions />
          ) : (
            <PlantDiseasePrediction />
          )}
        </Box>
      </Container>
    </>
  );
};

export default Advisory;
